import { trialPropsData } from 'client/util/Constants/FeatureTrialConstants';

const AuthNPoliciesAsidePanelLegacy = () => import('client/Security/AuthNPoliciesAsidePanel/AuthNPoliciesAsidePanelLegacy.vue');
const AuthNPoliciesMainPanel = () => import('client/Security/AuthNPoliciesMainPanel.vue');
const AuthNPoliciesSettings = () => import('client/Security/AuthNPoliciesSettings.vue');
const IpListsMainPanel = () => import('client/Security/IpListsMainPanel.vue');

export default [
  {
    path: '/security/authnpolicies',
    name: 'Conditional Access Policies',
    meta: {
      title: 'Conditional Access Policies',
      feature: 'zeroTrust',
      modalProps: trialPropsData.zeroTrust,
    },
    components: {
      mainPanel: AuthNPoliciesMainPanel,
    },
  },
  // Old Routes not included in tabbed page currently.
  {
    path: '/security/authnpolicies/settings',
    name: 'Conditional Access Policies Settings',
    meta: {
      title: 'Conditional Access Policies',
      feature: 'zeroTrust',
    },
    components: {
      mainPanel: AuthNPoliciesSettings,
    },
  },
  {
    path: '/security/authnpolicies/new',
    name: 'Add Conditonal Access Policy',
    meta: {
      title: 'Conditional Access Policies',
      feature: 'zeroTrust',
    },
    components: {
      mainPanel: AuthNPoliciesMainPanel,
      asidePanel: AuthNPoliciesAsidePanelLegacy,
    },
    props: {
      mainPanel: () => ({
        isAsideOpen: false,
        itemType: 'authNPolicies',
        selectedModelId: '',
        setSelectedModelId(selectedModelId) {
          this.selectedModelId = selectedModelId;
        },
      }),
      asidePanel: () => ({
        isExpanded: true,
        itemType: 'authNPolicies',
      }),
    },
  },
  {
    path: '/security/authnpolicies/:id',
    name: 'Conditional Access Policy Details',
    itemType: 'authNPolicies',
    meta: {
      title: 'Conditional Access Policies',
      feature: 'zeroTrust',
    },
    components: {
      mainPanel: AuthNPoliciesMainPanel,
      asidePanel: AuthNPoliciesAsidePanelLegacy,
    },
    props: {
      mainPanel: () => ({
        isAsideOpen: false,
        itemType: 'authNPolicies',
        selectedModelId: '',
        setSelectedModelId(selectedModelId) {
          this.selectedModelId = selectedModelId;
        },
      }),
      asidePanel: route => ({
        itemId: route.params.id,
        isExpanded: true,
        itemType: 'authNPolicies',
      }),
    },
  },
  {
    path: '/security/iplists',
    meta: {
      title: 'Conditional Lists',
      feature: 'zeroTrust',
      ignoreTrial: true,
      defaultPremiumBadgeVisibility: true,
    },
    components: {
      mainPanel: IpListsMainPanel,
    },
  },
];
